export function isSafari(): boolean {
  return (
    import.meta.client &&
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  );
}
